// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getTemplate, getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var TreeListRowVue2 = {
  name: 'KendoTreeListRow',
  // @ts-ignore
  emits: {
    'click': null,
    'dblclick': null,
    'contextmenu': null,
    'focus': null,
    'blur': null,
    'mousedown': null,
    'mouseup': null
  },
  props: {
    level: Array,
    expanded: Boolean,
    rowIndex: Number,
    levels: Array,
    ariaSetSize: Number,
    ariaPosInSet: Number,
    isSelected: Boolean,
    dataItem: Object,
    isAltRow: Boolean,
    onClick: Function,
    selectedField: String,
    rowHeight: Number,
    ariaRowIndex: Number,
    render: [String, Function, Object]
  },
  computed: {
    wrapperClass: function wrapperClass() {
      var _a = this.$props,
        isSelected = _a.isSelected,
        isAltRow = _a.isAltRow;
      return {
        'k-master-row': true,
        'k-selected': isSelected,
        'k-alt': isAltRow,
        'k-group-footer': this.dataItem && this.dataItem.footer
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    },
    handleDoubleClick: function handleDoubleClick(e) {
      this.$emit('dblclick', e);
    },
    handleContextMenu: function handleContextMenu(e) {
      this.$emit('contextmenu', e);
    },
    handleFocus: function handleFocus(e) {
      this.$emit('focus', e);
    },
    handleBlur: function handleBlur(e) {
      this.$emit('blur', e);
    },
    handleMousedown: function handleMousedown(e) {
      this.$emit('mousedown', e);
    },
    handleMouseup: function handleMouseup(e) {
      this.$emit('mouseup', e);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    var _a = this.$props,
      rowHeight = _a.rowHeight,
      expanded = _a.expanded,
      ariaRowIndex = _a.ariaRowIndex,
      level = _a.level,
      ariaSetSize = _a.ariaSetSize,
      ariaPosInSet = _a.ariaPosInSet,
      rowIndex = _a.rowIndex;
    var defaultRendering = h("tr", {
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick,
        "dblclick": this.handleDoubleClick,
        "contextmenu": this.handleContextMenu,
        "focus": this.handleFocus,
        "blur": this.handleBlur,
        "mousedown": this.handleMousedown,
        "mouseup": this.handleMouseup
      },
      onDblclick: this.handleDoubleClick,
      onContextmenu: this.handleContextMenu,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onMousedown: this.handleMousedown,
      onMouseup: this.handleMouseup,
      "class": this.wrapperClass,
      style: rowHeight !== undefined ? {
        height: rowHeight + 'px'
      } : undefined,
      "aria-expanded": expanded,
      attrs: this.v3 ? undefined : {
        "aria-expanded": expanded,
        role: 'row',
        "aria-rowindex": ariaRowIndex,
        "aria-level": level.length,
        "aria-posinset": ariaPosInSet,
        "aria-setsize": ariaSetSize,
        "data-grid-row-index": rowIndex
      },
      role: 'row',
      "aria-rowindex": ariaRowIndex,
      "aria-level": level.length,
      "aria-posinset": ariaPosInSet,
      "aria-setsize": ariaSetSize,
      "data-grid-row-index": rowIndex
    }, [defaultSlot]);
    return getTemplate.call(this, {
      h: h,
      template: this.$props.render,
      defaultRendering: defaultRendering,
      additionalProps: this.$props,
      additionalListeners: {
        click: this.handleClick
      },
      defaultSlots: defaultSlot,
      swapDefaultSlots: true
    });
  }
};
/**
 * @hidden
 */
var TreeListRow = TreeListRowVue2;
export { TreeListRow, TreeListRowVue2 };